/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/



export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: '/dashboard',
    name: 'dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  //{
  //url: '/analytics',
  //name: 'Analytics',
  //slug: 'analytics',
  //icon: 'TrendingUpIcon',
  //i18n: 'Analytics',
  //isDisabled: true
  //},
  {
    url: '/orders',
    //tag: '3',
    tagColor: 'primary',
    name: 'Orders',
    slug: 'orders',
    icon: 'ShoppingCartIcon',
    i18n: 'Orders'
  },
  //{
  //url: '/customers',
  //name: 'Customers',
  //slug: 'app-user-list',
  //icon: 'UsersIcon',
  //i18n: 'Customers',
  //isDisabled: true
  //},
  {
    url: '/forms',
    name: 'Order Forms',
    slug: 'forms',
    icon: 'FilePlusIcon',
    i18n: 'Order Forms'
  },
  {
    url: null,
    name: 'Products',
    icon: 'PackageIcon',
    i18n: 'Products',
    submenu: [
      {
        url: '/product',
        slug: 'product',
        name: 'Product',
        icon: 'InfoIcon',
        i18n: 'Product'
      },
      {
        url: '/product/add',
        slug: 'addproduct',
        name: 'Add Product',
        icon: 'InfoIcon',
        i18n: 'Add Product'
      },
      /*{
        url: '/product/edit',
        slug: 'editproduct',
        name: 'Edit Product',
        icon: 'InfoIcon',
        i18n: 'Edit Product'
      },*/
      {
        url: '/products/inventory',
        slug: 'inventory',
        name: 'Inventory',
        icon: 'HelpCircleIcon',
        i18n: 'Inventory'
      }
    ]
  },
  {
    url: '/coupons',
    name: 'Coupons',
    slug: 'coupons',
    icon: 'TagIcon',
    i18n: 'Coupons'
  },
  {
    url: '/team',
    name: 'team-management',
    slug: 'team-management',
    icon: 'BriefcaseIcon',
    i18n: 'Team Management'
  },
  {
    url: null,
    name: 'Billing',
    icon: 'FileTextIcon',
    i18n: 'Billing',
    submenu: [
      {
        url: '/billing/history',
        slug: 'billing-history',
        name: 'Billing History',
        icon: 'InfoIcon',
        i18n: 'Billing History'
      },
      /*{
        url: '/billing/information',
        slug: 'billing-information',
        name: 'Billing Information',
        icon: 'InfoIcon',
        i18n: 'Billing Information'
      },*/
      {
        url: '/billing/current-plan',
        slug: 'billing-current-plan',
        name: 'Current Plan',
        icon: 'InfoIcon',
        i18n: 'Current Plan'
      }/*,
      {
        url: '/billing/payout-settings',
        slug: 'billing-payout-settings',
        name: 'Payout Settings',
        icon: 'InfoIcon',
        i18n: 'Payout Settings'
      }*/
    ]
  },
  {
    url: '/reports',
    name: 'Reports',
    slug: 'reports',
    icon: 'BarChartIcon',
    i18n: 'Reports'
  },
  {
    header: 'Settings',
    icon: 'FileIcon',
    i18n: 'Settings',
    items: [
      {
        url: '/profile-settings',
        slug: 'profile-settings',
        name: 'Profile Settings',
        icon: 'UserIcon',
        i18n: 'Profile Settings'
      },
      {
        url: '/store-settings',
        slug: 'store-settings',
        name: 'Store Settings',
        icon: 'SettingsIcon',
        i18n: 'Store Settings'
      },
      //{
      //url: null,
      //name: 'Integration',
      //icon: 'LinkIcon',
      //i18n: 'Integration',
      //isDisabled: true
      //},
      {
        url: '/login/organization',
        slug: 'page-user-settings',
        name: 'Switch Store',
        icon: 'RepeatIcon',
        i18n: 'Switch Store'
      }
    ]
  },
  {
    url: null,
    name: 'Support',
    icon: 'SmileIcon',
    i18n: 'Support',
    submenu: [
      {
        url: '/support/knowledge-base',
        slug: 'knowledge-base',
        name: 'Knowledge Base',
        icon: 'InfoIcon',
        i18n: 'KnowledgeBase'
      },
      {
        url: '/support/faq',
        slug: 'support-faq',
        name: 'FAQ',
        icon: 'HelpCircleIcon',
        i18n: 'FAQ'
      },
      {
        url: '/support/contact-us',
        name: 'Contact Us',
        icon: 'LifeBuoyIcon',
        slug: 'contact-us',
        i18n: 'Contact Us'
      }
    ]
  },
  {
    url: '/logout',
    slug: 'logout',
    name: 'Logout',
    icon: 'LogOutIcon',
    i18n: 'Logout'
  }
]

